import { subdomains } from "@/common/consts";
import EducationHome from "@/pages/Education/Home/EducationHome.vue";
import EducationDetail from "@/pages/Education/Detail/EducationDetail.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        name: "EducationHome",
        meta: {
            subdomain: subdomains.Education
        },
        component: EducationHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/*",
        name: "EducationDetail",
        meta: {
            subdomain: subdomains.Education
        },
        component: EducationDetail
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.education.js